import { Room } from "../../chat/models/Rooms/Room"
import { MessengerRepository } from "../../../api/repositories/MessengerRepository";
import { UserRepository } from "../../../api/repositories/UserRepository";
import { RepositoryFabric } from "../../../api/repositories/RepositoryFabric";
import { UserProfile } from "../../../api/models/UserProfile";
import MessagesHelper from "../../chat/helpers/MessagesHelper"

import Message from "../../chat/models/Messages/Message"

type Groups = Record<string, Message[]>

export interface ExportStage {
    groups: Groups;
    roomId: string;
    title: string;
    user?: UserProfile | null;
}

export class ChatExportDataLoader {
    messengerRepository: MessengerRepository;
    userRepository: UserRepository;
    messageHelper: MessagesHelper;
    rooms: Room[];
    users: Record<number, UserProfile>;
    lang: string;

    constructor(repositories: RepositoryFabric, messagesHelper: MessagesHelper, rooms: Room[], users: Record<number, UserProfile>, lang: string) {
        this.messengerRepository = repositories.get(RepositoryFabric.MESSENGER);
        this.userRepository = repositories.get(RepositoryFabric.USER);
        this.rooms = rooms;
        this.messageHelper = messagesHelper;
        this.lang = lang;
        this.users = users;
    }

    public async getAllRooms() {
        const promises = this.rooms.map((room) => this.getGroups(room));
        return await Promise.all(promises);
    }

    private async getGroups(room: Room): Promise<ExportStage> {
        const roomMessages = await this.getRoomMessages(room.id);

        const user = this.users?.[room.userId]
            ? new UserProfile(this.users?.[room.userId]) : await this.userRepository?.profile(room.userId, ['firstName', 'lastName', 'company', 'position', 'userId']);

        return {
            groups: this.messageHelper.prepareMessages(roomMessages, this.lang, 'D', false) as Groups,
            roomId: room.id,
            title: user?.fullName || room.title,
            user: user
        };
    }

    private async getRoomMessages(roomId: string) {
        return (await this.messengerRepository.getMessagesByRoomId(roomId, { take: -1})).map((item: any) => new Message(item));
    }
}